import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { applyAccountLocale } from "@/i18n";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/users/me");
      applyAccountLocale(data.locale);
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = (data) => {
    localStorage.setItem("tt_token", data.access_token);
    const org = data.user.memberships?.[0]?.organization_id;
    if (org) localStorage.setItem("tt_org", org); else localStorage.removeItem("tt_org");
    applyAccountLocale(data.user.locale);
    setUser(data.user);
  };
  const signOut = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("tt_token");
    localStorage.removeItem("tt_org");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, refresh, signIn, signOut, upgradeOpen, setUpgradeOpen }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
